import { render } from "./ResearchView.vue?vue&type=template&id=886ff48c&scoped=true"
import script from "./ResearchView.vue?vue&type=script&lang=js"
export * from "./ResearchView.vue?vue&type=script&lang=js"

import "./ResearchView.vue?vue&type=style&index=0&id=886ff48c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-886ff48c"]])

export default __exports__